import type { ReactNode } from "react";

/** Stable plain text for sorting, filtering, and cmdk values when labels are React nodes. */
export function reactNodeToPlainString(node: ReactNode): string {
    if (node == null || node === false || node === true) {
        return "";
    }
    if (typeof node === "string" || typeof node === "number" || typeof node === "bigint") {
        return String(node);
    }
    if (Array.isArray(node)) {
        return node.map(reactNodeToPlainString).join(" ");
    }
    return "";
}
